export default __webpack_public_path__ + "static/media/course-sample2.99060eca.png";